import { useState } from "react";

import append from "ramda/src/append";

export const DATE_TYPE = "dateType";
export const ENTRATA_START_DATE = "entrataStartDate";
export const ENTRATA_END_DATE = "entrataEndDate";
export const ALLOW_ACCESS = "allowAccess";

const SETTINGS_TO_COPY = [DATE_TYPE, ENTRATA_START_DATE, ENTRATA_END_DATE, ALLOW_ACCESS];

export const useSettingsToCopy = () => {
  const [settingsToCopy, setSettingsToCopy] = useState(SETTINGS_TO_COPY);

  const handleSettingsChange = (name: string) => () =>
    setSettingsToCopy((prevSettingsToCopy) =>
      prevSettingsToCopy.includes(name)
        ? prevSettingsToCopy.filter((setting) => setting !== name)
        : append(name, prevSettingsToCopy)
    );

  const getSettingsChecked = (name: string) => settingsToCopy.includes(name);

  return {
    settingsToCopy,
    getSettingsChecked,
    handleSettingsChange,
  };
};
